import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import cn from 'classnames';
import TreeCheckNode from '../TreeCheckNode/TreeCheckNode';
import { useTreeCheckState } from '../../context';
import { getReplacedString } from '../../../../helpers/getReplacedString';
import { treeCheckThemes } from '../../constants/treeCheckThemes';
import styles from './TreeCheckNodeList.module.scss';

const { Search } = Input;

const dataThreshold = 7;

const TreeCheckNodeList = ({
  className,
  treeData,
  itemsToRender,
  loadData,
  onExpand,
  onCheck,
  getSearch,
  theme,
  checkable,
}) => {
  const validTheme = Object.values(treeCheckThemes).includes(theme)
    ? theme
    : treeCheckThemes.transparent;

  const { expandedKeys, loadedKeys, checkedKeys, halfCheckedKeys } =
    useTreeCheckState();

  const [shownItems, setShownItems] = useState(itemsToRender || []);
  const [search, setSearch] = useState('');

  useEffect(() => {
    let timeoutId = null;

    if (search.trim()) {
      timeoutId = setTimeout(() => {
        const newShownItems = itemsToRender?.filter((item) => {
          const itemTitle =
            typeof getSearch === 'function' ? getSearch(item) : item.title;

          const replacedTitle = getReplacedString(itemTitle);
          const replacedValue = getReplacedString(search.trim());

          return replacedTitle.includes(replacedValue);
        });

        setShownItems(newShownItems || []);
      }, 1000);
    } else {
      setShownItems(itemsToRender || []);
    }

    return () => clearTimeout(timeoutId);
  }, [itemsToRender, search]);

  const showExpandIcon =
    typeof loadData === 'function'
      ? shownItems.some((item) => item.isLeaf !== true)
      : shownItems.some((item) => Boolean(item.children?.length));

  return (
    <div
      className={cn(styles.root, styles[validTheme], className, {
        [styles.withPadding]: validTheme !== treeCheckThemes.transparent,
      })}
    >
      {itemsToRender.length > dataThreshold && (
        <Search
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={treeData[0].searchPlaceholder || ''}
          className={styles.search}
        />
      )}
      <ul className={styles.list}>
        {shownItems.map((item) => (
          <TreeCheckNode
            key={item.key}
            node={item}
            expanded={expandedKeys.has(item.key)}
            loaded={loadedKeys.has(item.key)}
            checked={checkedKeys.has(item.key)}
            halfChecked={halfCheckedKeys.has(item.key)}
            loadData={loadData}
            onExpand={onExpand}
            onCheck={onCheck}
            showExpandIcon={showExpandIcon}
            checkable={checkable}
          />
        ))}
      </ul>
    </div>
  );
};

export default TreeCheckNodeList;
